import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function Project() {
  const {
    t
  } = useLanguage();
  return <section className="relative py-32 px-6 bg-bg-secondary border-y border-[#222] overflow-hidden" data-id="element-46">
      <div className="max-w-6xl mx-auto" data-id="element-47">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-48">
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-49">
            <h2 className="text-4xl md:text-5xl font-serif text-white mb-6" data-id="element-50">
              {t('project.title')}
            </h2>
            <div className="h-px bg-gold w-24 mb-8 opacity-50" data-id="element-51"></div>

            <div className="space-y-6 text-gray-300 font-light text-lg mb-10" data-id="element-52">
              <p data-id="element-53">{t('project.p1')}</p>
              <p data-id="element-54">{t('project.p2')}</p>
              <p className="text-gold-light" data-id="element-55">{t('project.p3')}</p>
            </div>

            <a href="http://www.svatyvaclav.living" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 bg-gold text-bg-primary hover:bg-gold-light transition-colors duration-300 uppercase tracking-widest text-sm font-medium" data-id="element-56">
              {t('project.cta')}
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="grid grid-cols-2 gap-4 md:gap-6" data-id="element-57">
            <div className="bg-bg-primary p-8 border border-[#222] flex flex-col justify-center" data-id="element-58">
              <span className="text-4xl md:text-5xl font-serif text-gold mb-2" data-id="element-59">
                52
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-60">
                {t('project.stats.units')}
              </span>
            </div>
            <div className="bg-bg-primary p-8 border border-[#222] flex flex-col justify-center" data-id="element-61">
              <span className="text-4xl md:text-5xl font-serif text-gold mb-2" data-id="element-62">
                ~20
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-63">
                {t('project.stats.commercial')}
                <br data-id="element-64" />
                <span className="text-xs opacity-60" data-id="element-65">
                  {t('project.stats.commercialSub')}
                </span>
              </span>
            </div>
            <div className="bg-bg-primary p-8 border border-[#222] flex flex-col justify-center" data-id="element-66">
              <span className="text-4xl md:text-5xl font-serif text-gold mb-2" data-id="element-67">
                ~110
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-68">
                {t('project.stats.parking')}
              </span>
            </div>
            <div className="bg-bg-primary p-8 border border-[#222] flex flex-col justify-center" data-id="element-69">
              <span className="text-4xl md:text-5xl font-serif text-gold mb-2" data-id="element-70">
                +
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-71">
                {t('project.stats.storage')}
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}